/**
 * General ATL scripts used on both the website and the OBMS
 */

/**
 * Maximum summed size of files to upload at once (eg. in translation requests)
 */
const MAX_FILES_UPLOAD_SIZE = 2000000;

/**
 * Get the value of a URL parameter 
 * @param {string} sParam Name of the parameter
 * @return {string} The value of the URL parameter if set, null otherwise
 */
var getURLParameter = function getURLParameter(sParam) {
	var sPageURL = window.location.search.substring(1),
		sURLVariables = sPageURL.split('&'),
		sParameterName,
		i;

	for (i = 0; i < sURLVariables.length; i++) {
		sParameterName = sURLVariables[i].split('=');

		if (sParameterName[0] === sParam) {
			return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
		}
	}

	return null;
};

/**
 * Get the displayable message associated to an error got from a failed Ajax request
 * @param {JQuery.jqXHR} request The failed Ajax request
 * @param {string} errorThrown The default error message
 * @return {string} The error string to be displayed to the user
 */
var getAjaxErrorMessage = function getAjaxErrorMessage(request, errorThrown) {
	try {
		let errorObject = JSON.parse(request.responseText);
		console.debug(errorObject);
		if (Object.keys(errorObject).indexOf('description') !== -1) {
			return errorObject['description'];
		}
		return `${Object.keys(errorObject)[0]}: ${errorObject[Object.keys(errorObject)[0]]}`;
	} catch (e) {
		return errorThrown;
	}
}

//additional functions for data table
$.fn.dataTableExt.oApi.fnPagingInfo = function (oSettings) {
	return {
		"iStart": oSettings._iDisplayStart,
		"iEnd": oSettings.fnDisplayEnd(),
		"iLength": oSettings._iDisplayLength,
		"iTotal": oSettings.fnRecordsTotal(),
		"iFilteredTotal": oSettings.fnRecordsDisplay(),
		"iPage": Math.ceil(oSettings._iDisplayStart / oSettings._iDisplayLength),
		"iTotalPages": Math.ceil(oSettings.fnRecordsDisplay() / oSettings._iDisplayLength)
	};
}
$.extend($.fn.dataTableExt.oPagination, {
	"bootstrap": {
		"fnInit": function (oSettings, nPaging, fnDraw) {
			var oLang = oSettings.oLanguage.oPaginate;
			var fnClickHandler = function (e) {
				e.preventDefault();
				if (oSettings.oApi._fnPageChange(oSettings, e.data.action)) {
					fnDraw(oSettings);
				}
			};

			$(nPaging).addClass('pagination').append(
				'<ul>' +
				'<li class="prev disabled"><a href="#">&larr; ' + oLang.sPrevious + '</a></li>' +
				'<li class="next disabled"><a href="#">' + oLang.sNext + ' &rarr; </a></li>' +
				'</ul>'
			);
			var els = $('a', nPaging);
			$(els[0]).bind('click.DT', { action: "previous" }, fnClickHandler);
			$(els[1]).bind('click.DT', { action: "next" }, fnClickHandler);
		},

		"fnUpdate": function (oSettings, fnDraw) {
			var iListLength = 5;
			var oPaging = oSettings.oInstance.fnPagingInfo();
			var an = oSettings.aanFeatures.p;
			var i, j, sClass, iStart, iEnd, iHalf = Math.floor(iListLength / 2);

			if (oPaging.iTotalPages < iListLength) {
				iStart = 1;
				iEnd = oPaging.iTotalPages;
			}
			else if (oPaging.iPage <= iHalf) {
				iStart = 1;
				iEnd = iListLength;
			} else if (oPaging.iPage >= (oPaging.iTotalPages - iHalf)) {
				iStart = oPaging.iTotalPages - iListLength + 1;
				iEnd = oPaging.iTotalPages;
			} else {
				iStart = oPaging.iPage - iHalf + 1;
				iEnd = iStart + iListLength - 1;
			}

			for (i = 0; i < an.length; i++) {
				// remove the middle elements
				$('li:gt(0)', an[i]).filter(':not(:last)').remove();

				// add the new list items and their event handlers
				for (j = iStart; j <= iEnd; j++) {
					sClass = (j == oPaging.iPage + 1) ? 'class="active"' : '';
					$('<li ' + sClass + '><a href="#">' + j + '</a></li>')
						.insertBefore($('li:last', an[i])[0])
						.bind('click', function (e) {
							e.preventDefault();
							oSettings._iDisplayStart = (parseInt($('a', this).text(), 10) - 1) * oPaging.iLength;
							fnDraw(oSettings);
						});
				}

				// add / remove disabled classes from the static elements
				if (oPaging.iPage === 0) {
					$('li:first', an[i]).addClass('disabled');
				} else {
					$('li:first', an[i]).removeClass('disabled');
				}

				if (oPaging.iPage === oPaging.iTotalPages - 1 || oPaging.iTotalPages === 0) {
					$('li:last', an[i]).addClass('disabled');
				} else {
					$('li:last', an[i]).removeClass('disabled');
				}
			}
		}
	}
});

$(function () {

	// set timezone
	moment.tz.setDefault("Australia/Sydney");

	var failed_tries = 0;

	if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
		$('input, textarea, select').on('focus', function () {
			$('#site-header').css({ position: 'absolute' })
		})
		$('input, textarea, select').on('blur', function () {
			$('#site-header').css({ position: 'fixed' })
		})
	}


	/* ATL ALERTS */

	if ($('#atl-alerts-div').length) {
		$('#atl-alerts-div').append(ATLAlerts.displayAlerts(true));
	}

	/* FORMAT FIELDS */

	// add placeholders to textareas
	$('input, textarea').placeholder();

	//datepicker
	$('.datepicker').datepicker({ dateFormat: 'DD dd/mm/yy' });

	//datetimepicker
	$('.datetimepicker').datetimepicker({
		separator: " @ ",
		timeFormat: "hh:mm tt",
		dateFormat: 'DD dd/mm/yy',
		controlType: 'select',
		hour: 8
	});

	//duration
	$('.durationpicker').durationpicker({
		controlType: 'select'
	});

	/* CHOSEN - IMPROVE SELECTS */
	$('[data-rel="chosen"],[rel="chosen"]').chosen();

	/* CLOSE BUTTONS ON HEADERS */
	$(document).on('click', '.btn-close', function (e) {
		e.preventDefault();
		$(this).parent().parent().parent().fadeOut();
	});


	/* NAVIGATION */

	$('.actions').on('click', '.go-back', function (e) {
		e.preventDefault();
		window.history.back();
	});

	$('.booking-large-buttons a').html(function (index, html) {
		return '<div class="icon-inline link-hover ease-out"></div>'
			+ '<div class="link-text">' + html + '</div>';
	});

	$('.nav-site a').click(function (e) {
		if ($('.sub-menu', $(this).parent()).length > 0) {

			if ($(window).width() <= 780) {
				e.preventDefault();
				$('.nav', $(this).parents()).css('min-height', $('.sub-menu', $(this).parent()).height());
				$('.sub-menu', $(this).parent()).addClass('nav-open');
			}
		}
	});

	$(document).on('click', '.back-main-menu a', function (e) {
		e.preventDefault();
		$('.nav', $(this).parents()).removeAttr('style');
		$(this).parent().parent().removeClass('nav-open');
	});

	$('.nav-site > li').hoverIntent(function (e) {
		if ($(window).width() > 780 && $('.sub-menu', this).length > 0) {
			$('.sub-menu', this).slideDown();
			e.preventDefault();
		}
	}, function (e) {
		if ($(window).width() > 780 && $('.sub-menu', this).length > 0) {
			$('.sub-menu', this).slideUp();
			e.preventDefault();
		}
	});

	$('.sub-menu').append('<li class="back-main-menu"><a href="#">&lt; back to main menu</a></li>');

	$('#toggle-nav').click(function (e) {
		e.preventDefault();
		$('#site-header .nav').slideToggle(400, function () {
			$(this).toggleClass('nav-open').removeAttr('style');
		});
	});

	$(".tab-menu a").click(function (e) {
		e.preventDefault();
		$(this).tab('show');
	});

	/* HOME PAGE */

	// time for each slider on front page slider
	$('#front-page-slider').banner({
		transition: 7000
	});

	// home page blog
	$('.social-feed-container').mouseenter(function (e) {
		var post = this,
			title = post.getElementsByClassName("post-title")[0];

		title.style.textDecoration = "underline";

		$(post).mouseleave(function (e) {
			title.style.textDecoration = "none";
		});
	});

	$('.staff-list li').hover(function () {
		var uid = $(this).parent().attr('id');
		var index = $(this).index() + 1;
		$('li:not(:nth-child(' + index + '))', $(this).parent()).addClass('transparent');
		$('.staff-list:not(#' + uid + ') li').addClass('transparent');
	}, function () {
		$('.staff-list li').removeClass('transparent');
	});

	$('.testimonial .read-more a, .testimonial .read-less a').click(function (e) {
		e.preventDefault();
		$(this).parent().parent().toggleClass('expanded');
	});

	$('.naati-language-list li span.a:contains("YES")').parent().addClass('white-hilighted');
	$('.naati-language-list li span.a:contains("NO")').parent().addClass('pink-hilighted');


	general_service_resize()
	$(window).resize(function () {
		general_service_resize();

		if ($(window).width() <= 780) {
			$('#site-header .nav').removeAttr('style');
			$('.sub-menu').removeClass('nav-open').removeAttr('style');
		}
	});

	$('.btn-reset').click(function (e) {
		e.preventDefault();
		$('input[type=text], input[type=email], textarea, select', $(this).parents('form')).val('');
		$('input[type=checkbox]', $(this).parents('form')).prop('checked', false);
		var radios = new Array();
		$('input[type=radio]', $(this).parents('form')).each(function () {
			if ($.inArray($(this).attr('name'), radios) == -1) {
				$('input[type=radio][name=' + $(this).attr('name') + ']', $(this).parents('form')).prop("checked", false);
				$('input[type=radio][name=' + $(this).attr('name') + ']', $(this).parents('form')).first().prop("checked", true);
				radios.push($(this).attr('name'));
			}
		});
		show_job_type_field($('input[name=job_type]').val());
	});

	$('select.state-field').on('change', function (e) {
		if (this.value === "") {
			this.style.color = "#888";
		}
		else {
			this.style.color = "#131534";
		}
	});
	$('select.state-field').trigger('change');

	// $('#invoice_use_profile').click(function (e) {
	// 	if ($(this).is(':checked')) {
	// 		$('.client_profile').each(function () {
	// 			var iname = "invoice_" + this.id;
	// 			document.getElementById(iname).value = this.value;
	// 		});
	// 	} else {
	// 		$('.client_profile').each(function () {
	// 			var iname = "invoice_" + this.id;
	// 			document.getElementById(iname).value = "";
	// 		});
	// 	}
	// });

	// Spinner rotation
	$('.spinner-roller').append('<div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>');

	// BOOKING FORMS

	$("#additional-email-checkbox").click(function (e) {
		var checkbox = this,
			row = document.getElementById("additional-email-row"),
			emailInput = document.getElementById("additional-email");

		if ($(checkbox).is(":checked")) {
			$(row).show(500);
		}
		else {
			emailInput.value = "";
			$(row).hide(500);
		}
	});
/*
	$('form.booking-form').submit(function (e) {

		if ($('#company').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Name of Company / Individual field.");
			failed_tries_popup();
			return false;
		}

		if ($('#street_address').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Street Address field.");
			failed_tries_popup();
			return false;
		}

		if ($('#state').val() == "" || $('#postcode').val() == "" || $('#suburb').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the City, Suburb and Postcode fields.");
			failed_tries_popup();
			return false;
		}

		if ($('#telephone').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Telephone field");
			failed_tries_popup();
			return false;
		}

		if ($('#email').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Email Address field");
			failed_tries_popup();
			return false;
		}

		if (!isValidEmail($('#email').val())) {
			failed_tries++;
			e.preventDefault();
			alert("Please enter a valid Email Address");
			failed_tries_popup();
			return false;
		}

		if ($('#email').val() != $('#confirm-email').val()) {
			failed_tries++;
			e.preventDefault();
			alert("The email and confirmation email addresses do not match");
			failed_tries_popup();
			return false;
		}

		if ($("#additional-email-checkbox").is(":checked") && !isValidEmail($('#additional-email').val())) {
			failed_tries++;
			e.preventDefault();
			alert("Please enter a valid Additional Email Address");
			failed_tries_popup();
			return false;
		}

		var errors = false;

		if (!isValidDateTime($('#datetime').val())) {
			failed_tries++;
			e.preventDefault();
			alert("Please check the format of the date and time, 'Day dd/mm/yyyy @ HH:ii am|pm' for instance 'Monday 01/12/2013 @ 12:00 am'");
			errors = true;
			failed_tries_popup();
			return false;
		}

		if (!isFutureDate($('#datetime').val())) {
			failed_tries++;
			e.preventDefault();
			alert("Please select a future date and time");
			errors = true;
			failed_tries_popup();
			return false;
		}

		if (errors) {
			failed_tries++;
			e.preventDefault();
			failed_tries_popup();
			return false;
		}

		if ($('#duration').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Duration field");
			failed_tries_popup();
			return false;
		}
		else if (!isValidDuration($('#duration').val())) {
			failed_tries++;
			e.preventDefault();
			alert("Please enter a valid Duration");
			reset_spinner($(this));
			failed_tries_popup();
			return false;
		}

		var language = document.getElementById('language').value;
		if (language == "" || language == "Select a language" || (language == "Other" && document.getElementById('other-language-name').value == "")) {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Language field");
			failed_tries_popup();
			return false;
		}

		if ($('#client').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Client's Name field");
			failed_tries_popup();
			return false;
		}

		if ($('#job_reference').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Claim No / Job Ref field");
			failed_tries_popup();
			return false;
		}

		if ($('#contact_person').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Contact Person field");
			failed_tries_popup();
			return false;
		}

		if (!$('[name=job_type]:checked').length) {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Job Type field");
			failed_tries_popup();
			return false;
		}

		if ($('[name=job_type]:checked').val() === 'onsite') {
			if ($('#job_location').val() == "") {
				failed_tries++;
				e.preventDefault();
				alert("Please fill out the Job Location field");
				failed_tries_popup();
				return false;
			}

		}
		else if ($('[name=job_type]:checked').val() === 'videoconference') {
			if ($('#videoconference-info').val() === "") {
				failed_tries++;
				e.preventDefault();
				alert("Please fill out the Videoconference type field");
				failed_tries_popup();
				return false;
			}
		}
		else { // teleconference
			if ($('#job_phone').val() == "") {
				failed_tries++;
				e.preventDefault();
				alert("Please fill out the Job Phone Number field");
				failed_tries_popup();
				return false;
			}
		}

		if ($('#invoice_company').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Invoice Address field");
			failed_tries_popup();
			return false;
		}

		if ($('#instructed_by').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Instructed By field");
			failed_tries_popup();
			return false;
		}

		if ($('#contact_phone').val() == "") {
			failed_tries++;
			e.preventDefault();
			alert("Please fill out the Contact Phone No. field");
			failed_tries_popup();
			return false;
		}

		if ($('#undertaking:checked').length == 0) {
			failed_tries++;
			e.preventDefault();
			alert("Please agree to the terms");
			failed_tries_popup();
			return false;
		}

		function failed_tries_popup() {
			if (failed_tries >= 3 && $('form.booking-form').attr('id') == "book-an-interpreter") {

				e.preventDefault();

				var dialog = $('#atl-duplicate-dialog');
				var failed_input = '<textarea id="failed_input" name="failed_input" placeholder="Enter your booking details here" rows="13" style="width:97.5%"></textarea>';

				$('h4', dialog).text("Any problem in creating new booking ?");
				$('.modal-body', dialog).html("<p>We have detected a few failed submissions of this form.<br />Please use the area bellow to provide your contact details/your interpreting request and we will get back to you as soon as possible.</p><p><big>Please precise your name, phone number and email address.</big></p><br />" + failed_input + "<br />");
				$('.btn-action', dialog).off();
				$('.btn-action', dialog).attr("href", "#");
				$('.yes', dialog).width("260px");
				$('.yes', dialog).text("Keep on booking manually");
				$('.yes', dialog).on('click', function () {
					dialog.modal('hide');
					return false;
				});

				$('.no', dialog).text("Submit");
				$('.no', dialog).on('click', function () {
					$('#failed_form').val($('#failed_input').val());
					$('#failed_new_booking').submit();
					this.style.display = "none";
					return false;
				});

				dialog.modal('show');
			}
		}

		if ($(this).attr('id') == "book-an-interpreter" && $("[name=edition_confirmed]", this).length == 0) {
			var form = this;
			e.preventDefault();

			var dialog = $('#atl-confirm-dialog');

			$('h4', dialog).text("Submit this booking");

			$('.modal-body', dialog).html("<p>Are you sure you want to submit this booking form ?</p>");
			$('.btn-dark-blue', dialog).off();
			$('.btn-dark-blue', dialog).attr("href", "#");
			$('.btn-dark-blue', dialog).text("Yes");
			$('.btn-dark-blue', dialog).on('click', function () {
				$(this).hide(100, function () {
					this.style.display = "none";
					$(form).append('<input type="hidden" name="edition_confirmed" value="" />');
					$('[name=submit]', form).click();
				});
				return false;
			});

			dialog.modal('show');
		}

		if ($(this).attr('id') == "edit_booking" && $("[name=edition_confirmed]", this).length == 0) {
			var form = this;
			e.preventDefault();

			var dialog = $('#atl-confirm-dialog');

			$('h4', dialog).text("Edit this booking");

			$('.modal-body', dialog).html("<p>Are you sure you want to submit this edition form ?</p>");
			$('.btn-dark-blue', dialog).off();
			$('.btn-dark-blue', dialog).attr("href", "#");
			$('.btn-dark-blue', dialog).text("Yes");
			$('.btn-dark-blue', dialog).on('click', function () {
				$(form).append('<input type="hidden" name="edition_confirmed" value="" />');
				$('[name=submit]', form).click();
				this.style.display = "none";
				return false;
			});

			dialog.modal('show');
		}
	});
*/
/*
	$('.job-code-radio').click(function (e) { // display sub job codes when a job code is selected
		var job_code = this.value;
		showSubJobCodes($("input[name=job_type]").val(), job_code);
	});*/


	/***** CLIENT DASHBOARD ******/

	$('input[type=file]').each(function (e) {
		if (this.id != "attachments-allocation" &&
			this.id != "attachments-failed-new-translation" &&
			this.id != "attachments-translated-files") {
			$(this).customFile();
		}
	});

	$('input[name=job_type]').on('change', function (e) {
		handleJobTypeChange($(this).val());
	});

	$('select#interpreter_to_connect').on('change', function() {
		handleInterpreterToConnectChange($(this).val());
	});

	//phone numbers mask
	$('.phone-mask').each(function (i) {

		$(this).on('keypress paste textInput input', function () {
			var val = this.value;
			if (val.length == 1) {
				if (val == '(') {
					$(this).mask('(99) 9999 9999', { "translation": { "(": null, ")": null } });
					$(this).val('(');
				}
			} else if (val.length == 2) {
				if (val != "04") {
					$(this).mask('(99) 9999 9999', { "translation": { "(": null, ")": null } });
				} else {
					$(this).mask('9999 999 999');
				}
				$(this).val(val);
			}
			else if (val.length === 0) {
				$(this).unmask();
				$(this).val("");
			}
		});
	});

	$('.mobile-phone-mask').mask("9999 999 999", { placeholder: " " });
	$('.fax-mask').mask("(99) 9999 9999", { placeholder: " " });

	$('.postcode-mask').mask("9999", { placeholder: "Postcode" });
	$('.birthdate-mask').mask("99/99/9999", { placeholder: "DD/MM/YYYY" });
	$('.tfn-mask').mask("999 999 999", { placeholder: " " });


	function testimonials_homepage($ele) {
		$ele.fadeIn(1000).delay(5000).fadeOut(1000, function () {
			var $next = $(this).next('.testimonial');
			testimonials_homepage($next.length > 0 ? $next : $(this).parent().children().first());
		});
	}

	testimonials_homepage($("#testimonials-carousel > .testimonial").first());
});

/***** FUNCTIONS *****/

function general_service_resize() {
	if ($(window).width() <= 700) {
		$('.general-service-block h6').addClass('auto-line-height');
		$('.general-service-block h6').css('line-height', Math.round($('.general-service-block h6').width() * 0.37) + 'px');
	} else {
		$('.general-service-block h6').removeClass('auto-line-height');
	}
}

function isValidDateTime(datetime) {
	// First check for the pattern
	if (!/^[A-Za-z]{6,9} \d{2}\/\d{2}\/\d{4} @ \d{2}:\d{2} (am|pm)$/.test(datetime))
		return false;

	var mainParts = datetime.split(" ");

	//Checking day
	var day = mainParts[0].toLowerCase();
	var days = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
	if (days.indexOf(day) == -1)
		return false;

	// Parse the date parts to integers
	var dateParts = mainParts[1].split("/");
	var day = parseInt(dateParts[0], 10);
	var month = parseInt(dateParts[1], 10);
	var year = parseInt(dateParts[2], 10);

	// Check the ranges of month and year
	if (year < 1000 || year > 3000 || month == 0 || month > 12)
		return false;

	var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

	// Adjust for leap years
	if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
		monthLength[1] = 29;

	// Check the range of the day
	if (day <= 0 || day > monthLength[month - 1])
		return false;

	// Parse the time parts to integers
	var timeParts = mainParts[3].split(":");
	var hours = parseInt(timeParts[0], 10);
	var minutes = parseInt(timeParts[1], 10);

	// check range of hours
	if (hours < 1 || hours > 12)
		return false;

	//check range of minutes
	if (minutes < 0 || minutes > 59)
		return false;

	//check am|pm
	var meridiem = mainParts[4];
	if (meridiem != 'am' && meridiem != 'pm')
		return false;

	//date time validated
	return true;
}

function isFutureDate(datetime) {
	if (!isValidDateTime(datetime))
		return false;

	var mainParts = datetime.split(" ");

	// Parse the date parts to integers
	var dateParts = mainParts[1].split("/");
	var day = parseInt(dateParts[0], 10);
	var month = parseInt(dateParts[1], 10) - 1;
	var year = parseInt(dateParts[2], 10);

	// Parse the time parts to integers
	var timeParts = mainParts[3].split(":");
	var hours = parseInt(timeParts[0], 10);
	var minutes = parseInt(timeParts[1], 10);
	var meridiem = mainParts[4];

	if (meridiem == 'am' && hours == 12) {
		hours = 0;
	} else if (meridiem == 'pm' && hours != 12) {
		hours += 12;
	}

	var new_datetime = new Date(year, month, day, hours, minutes);
	var today = new Date();
	return new_datetime >= today;
}

/**
 * Check if the format of a string corresponds to a valid email address
 * @param  {String}  address The String to check
 * @return {Boolean}         True if the String passed corresponds to a valid email address, false otherwise.
 */
function isValidEmail(address) {
	var pattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
	let trimmedAddress = address.trim();

	if (trimmedAddress.match(pattern)) {
		return true;
	}
	else {
		return false;
	}
}

/**
 * Check if the format of a string corresponds to a valid duration
 * @param  {String}  duration	The String to check
 * @return {Boolean}       		True if the String passed corresponds to a valid duration, false otherwise.
 */
function isValidDuration(duration) {

	var patternDays = '(((0\.5)|([1-9]|10)(\.5)?)d)', // between 0.5 and 10.5 days
		patternHours = '(([1-9]|1[0-9]|2[0-3])h)', // between 1 and 23 hours
		patternMins = '(([1-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9])m)', // between 1 and 59 minutes
		pattern = '^' + patternDays + '? ?' + patternHours + '? ?' + patternMins + '?$'; // all patterns are optional

	if (duration != "" && duration.match(new RegExp(pattern, 'g'))) { // think about excluding empty string
		return true;
	}
	else {
		return false;
	}
}


/**
 * Show the cell holding the sub job codes corresponding to the selected job code
 * @param {String} job_type Selected job type
 * @param {String} job_code Parent job code
 * @param {String} sub_job_code (Optional) Selected sub- job code
 */
function showSubJobCodes(job_type, job_code, sub_job_code) {
	sub_job_code = sub_job_code || "";

	$("#sub-job-codes-row").hide(); // only show sub job codes row if there are options to select

	if (job_type === "onsite") { // show sub job codes for onsite jobs only
		$(".sub-job-codes").each(function () {
			let subJobCodesBlock = this;
			$(subJobCodesBlock).hide(); // hide all sub job code blocks
			let nbSubJobCodes = 0; // count number of sub job codes
			$(subJobCodesBlock).find("input:radio").each(function () {
				nbSubJobCodes++;
				$(this).attr('checked', this.value === sub_job_code ? true : null);
			});

			// show sub job codes matching selected job code if there are several options
			if (subJobCodesBlock.id === job_code + "-sub-job-codes") {
				if (nbSubJobCodes > 1) {
					$("#sub-job-codes-row").show();
					$(subJobCodesBlock).show();
				}
			}
		});
	}
}

function handleJobTypeChange(jobType) {
	if (jobType === "teleconference") { // hide the onsite/videoconference fields and display the teleconference ones
		$('.videoconference-field').hide();
		$('.onsite-field').hide();
		$('.teleconference-field').show();
		$('.timezone-field').show();
		if ($('#interpreter_to_connect').val() == 1) {
			$("#nes_phone_row").show();
		} else {
			$("#nes_phone_row").hide();
		}
		document.getElementById("sub-job-codes-row").style.display = "none";
	}
	else if (jobType === "videoconference") { // hide the onsite/teleconference fields and display the videoconference ones
		$('.teleconference-field').hide();
		$('#short-teleconference').attr('checked', null);
		$('.onsite-field').hide();
		$('.timezone-field').show();
		$('.videoconference-field').show();
		document.getElementById("sub-job-codes-row").style.display = "none";
	}
	else { // hide the tele/videoconference fields and display the onsite ones
		$('.teleconference-field').hide();
		$('#short-teleconference').attr('checked', null);
		$('.videoconference-field').hide();
		$('.timezone-field').hide();
		$('.onsite-field').show();

		// display sub job codes row if a job code is selected
		$('.job-code-radio').each(function (index, jobCodeRadio) {
			if ($(jobCodeRadio).is(":checked")) {
				showSubJobCodes(jobType, jobCodeRadio.value);
			}
		});
	}
}


function handleInterpreterToConnectChange(value) {
	if (value == 1) {
		$("#nes_phone_row").show();
	} else {
		$("#nes_phone_row").hide();
	}
}

/**
	 * Get the job code parent of a sub- job code
	 * @param  {String} sub_job_code The sub- job code of which we want the parent
	 * @return {String} The job code category the sub- job code belongs to
	 */
function atl_client_parent_job_code(sub_job_code) {
	sub_job_code = sub_job_code || "";

	switch (sub_job_code) {
		case "court":
		case "court_conference":
		case "court_in_room":
		case "court conference":
		case "in room":
			return "court";

		case "medical":
		case "medical centre":
		case "medical home visit":
		case "library":
		case "work visit":
		case "medical_centre":
		case "medical_home_visit":
		case "medical_library":
		case "medical_work_place_visit":
		case "medical_distant_suburb":
			return "medical";

		case "conference":
		case "conference_home_visit":
		case "conference_correctional_centre":
		case "conference_work_place_visit":
		case "conference_airport":
		case "conference_distant_suburb":
		case "office":
		case "conference home visit":
		case "correctional centre":
			return "conference";

		case "investigation":
			return "investigation";
				
		case "federal_court":
		case "federal_court_conference":
		case "federal_court_in_room":
			return "federal_court";
					
		default:
			return "";
	}
}

/**
 * Display the booking timezone
 */
function atl_client_display_timezone(timezone) {
	switch (timezone) {
		case "AEDT": return "NSW/TAS/VIC/ACT";
		case "AEST": return "QLD";
		case "ACST": return "SA";
		case "ACWST": return "NT";
		case "AWST": return "WA";
		default: return timezone;
	}
}

/**
 * Gets the list of available sub- job codes for a Job Code
 *
 * @param int $type Job Code of the booking.
 * @return string[] Array of sub- job codes.
 */
function atl_client_sub_job_codes(code)
{
	switch (code) {
		case "court":
			return [
				"court_conference",
				"court_in_room"
			];

		case "federal_court":
			return [
				"federal_court"
			];

		case "medical":
			return [
				"medical_centre",
				"medical_home_visit",
				"medical_library",
				"medical_work_place_visit",
				"medical_distant_suburb"
			];

		case "conference":
			return [
				"conference_office",
				"conference_home_visit",
				"conference_correctional_centre",
				"conference_work_place_visit",
				"conference_airport",
				"conference_distant_suburb"
			];

		case "investigation":
			return [
				"investigation"
			];

		default:
			return [];
	}
}

/**
 * Get all the names of Australian states
 *
 * @return string[] Array containing the names of all the Australian states, ordered alphabetically.
 */
function atl_client_get_states() {
	return [
		'ACT',
		'NSW',
		'NT',
		'QLD',
		'SA',
		'TAS',
		'VIC',
		'WA'
	];
}

/** 
 * Hook to edit the interpreter code when printing it
 *
 * @param string code Interpreter code of the interpreter.
 * @return string Edited interpreter code.
 */
function atl_print_interpreter_code(code) {
	if (code == "XXXX1") {
		code = "<span style='font-weight:bold; color:#f00; font-size:1.2em;'>" + code + "</span>";
	}
	return code;
}

/** 
 * Gets the displayable ID (reference) of a booking or a template
 *
 * @param int id ID of the element.
 * @param string type Type of the element. For a booking, it corresponds to the way it has been made (user logged in, logged out, administration...).
 * @return string Reference of the booking.
 */
function atl_client_ref(id, type = "")
{
	switch (type) {

		case "website":
			return "#B" + id;

		case "logout":
			return "#A" + id;

		case "email": return "#M" + id;
		case "phone":
		case "facsimile":
			return "#M" + id;

		case "template":
			return "#T" + id;
		case "translation":
			return "#X" + id;

		case "translation_admin":
		case "translation_email":
		case "translation_mail":
		case "translation_facsimile":
			return "#H" + id;

		default:
			return "#" + id;
	}
}

/**
 * Add a loader to a button and disables it
 * @param {HTMLElement} button 
 */
function addLoaderToButton(button) {
	$(button).append(
		'<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'
	);

	$(button).attr("disabled", "");
}

/**
 * Remove the loader from a button and re-enables it
 * @param {HTMLElement} button 
 */
function removeLoaderFromButton(button) {
	$(button).find('.spinner-border').remove();
	$(button).attr("disabled", null);
}

function getApiURL(endpoint) {
	if (endpoint) {
		return config.api_url + "/" + endpoint;
	}
	return config.old_api_url;
}

/**
 *
 * @param data
 * @param isAdmin
 * @returns {string}
 */
function label_status(data, isAdmin) {
    if (data) {
        var isBookingInFuture = !data.booking_id || moment().isBefore(moment(data.datetime));
        // var isBooking = (data.ref.indexOf('#B') || data.ref.indexOf('#M') )
        switch (data.status) {
            case "requested":
                return '<span class="label label-requested">Requested</span>';

            case "quote requested":
                return '<span class="label label-requested">Quote Requested</span>';
				
			case "deposit":
                return '<span class="label label-pending">Deposit</span>';

            case "confirmed":
                if (isBookingInFuture) return '<span class="label label-confirmed">Confirmed</span>';
                return '<span class="label label-completed">Completed</span>';

            case "processed":
                if (isAdmin) return '<span class="label label-confirmed">Processed</span>';
                return '<span class="label label-confirmed">Confirmed</span>';

            case "cancel processed":
                return '<span class="label label-confirmed">Cancel Processed</span>';

            case "to be sent":
                if (isAdmin) return '<span class="label label-send">To Be Sent</span>';
                return '<span class="label label-confirmed">Confirmed</span>';

            case "pending":
                return '<span class="label label-pending">Pending</span>';

            case "cancelling":
                return '<span class="label label-cancelling">Cancelling</span>';

            case "cancelled":
            case "cancelled no fees":
                return '<span class="label label-cancelled">Cancelled</span>';

            case "cancellation job":
                if (isAdmin) return '<span class="label label-job">Cancelled Job</span>';
                return '<span class="label label-cancelled">Cancelled</span>';

            case "not provided":
                return '<span class="label label-not-provided">Not provided</span>';

            case "job":
                if (isAdmin) return '<span class="label label-job">Job</span>';
                return '<span class="label label-completed">Completed</span>';

            case "not attend":
                return '<span class="label label-job">Not attend</span>';

            case "quotation":
                return '<span class="label label-quotation">Quoted</span>';

			case "quote expired":
                return '<span class="label label-cancelled">Quote expired</span>';

			case "quote accepted":
				return '<span class="label label-quotation-accepted">Quote accepted</span>';

            case "sent":
                if (isAdmin) return '<span class="label label-sent">Sent</span>';
                return '<span class="label label-confirmed">Confirmed</span>';

            default:
                return '<span class="label">' + data.status + '</span>';
        }
    }
}

/**
 * Displays nicely the association status of a file
 *
 * @param string association Association status of the file.
 * @return string HTML code for the label of the status.
 */
function atl_client_translation_allocation_status(association, status = "sent") {
	if (Array.isArray(association)) {
		if (association.length > 1) {//several interpreters proposed
			return '<span class="label label-pending">Multi</span>';
		} else if (association.length == 0) {
			return '<span class="label label-cancelled">Not Allocated</span>'; 
		} else {
			if (association[0].interpreter_code == "XXXX1") {
				return atl_print_interpreter_code(association[0].interpreter_code);
			} else if (association[0].status !== undefined) {
				if (association[0].status == 'associated') {
					return '<span class="label label-confirmed">' + association[0].interpreter_code + '</span>';
				} else if (association[0].status == 'requested') {
					return '<span class="label label-completed">' + association[0].interpreter_code + '</span>';
				}
				return '<span class="label label-cancelled">Not Allocated</span>';
			} else if (association[0].interpreter_code == undefined) {
				return '<span class="label label-cancelled">Not Allocated</span>';
			} else {
				return association[0].interpreter_code;
			}
		}
	} else if (association == "XXXX1") {
		return atl_print_interpreter_code(association);
	} else if (status == 'associated') {
		return '<span class="label label-confirmed">' + association + '</span>';
	} else if (status == 'requested') {
		return '<span class="label label-completed">' + association + '</span>';
	} else {
		return '<span class="label label-pending"> - </span>';
	}
 }